import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, HelpCircle, ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { companyInfo } from '../data/mock';

const FAQPage = () => {
  const navigate = useNavigate();

  const faqCategories = [
    {
      category: "AC Repair Roseville CA",
      faqs: [
        {
          question: "Where can I find reliable AC repair in Roseville CA?",
          answer: "Romano Heating & Cooling provides reliable AC repair in Roseville CA. Located at 1316 Church Street, Roseville, CA 95678, we've been serving the community since 2005. Our certified technicians offer same-day AC repair service, 24/7 emergency repairs, and our famous $49 tune-up. Call (916) 274-9021 for fast, professional AC repair in Roseville CA."
        },
        {
          question: "How much does AC repair cost in Roseville CA?",
          answer: "AC repair costs in Roseville CA vary based on the issue. Romano Heating & Cooling offers competitive pricing with free estimates and no hidden fees. Our $49 AC tune-up helps prevent costly repairs. Common repairs range from $150-$500, while major repairs like compressor replacement may cost more. We offer financing options. Call (916) 274-9021 for a free AC repair estimate."
        },
        {
          question: "Do you offer emergency AC repair in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling offers 24/7 emergency AC repair in Roseville CA. When your air conditioning breaks down unexpectedly, our technicians are available day and night to restore your comfort. We understand AC emergencies can't wait, especially during hot Roseville summers. Call (916) 274-9021 anytime."
        },
        {
          question: "What AC brands do you repair in Roseville CA?",
          answer: "We repair all major AC brands in Roseville CA including Lennox, Carrier, Trane, Rheem, Goodman, Bryant, American Standard, York, Amana, and more. Our certified technicians are trained on all equipment types and have the parts and expertise to fix any air conditioning system."
        }
      ]
    },
    {
      category: "HVAC Repair Roseville CA",
      faqs: [
        {
          question: "What HVAC repair services are available in Roseville CA?",
          answer: "Romano Heating & Cooling offers comprehensive HVAC repair in Roseville CA including: AC repair and installation, furnace repair and replacement, heat pump services, air duct cleaning, thermostat installation, and 24/7 emergency HVAC services. We service all major brands and provide upfront pricing."
        },
        {
          question: "How do I know if I need HVAC repair in Roseville CA?",
          answer: "Signs you need HVAC repair include: unusual noises, weak airflow, inconsistent temperatures, strange odors, increased energy bills, frequent cycling, or the system not turning on. If you notice any of these issues, call Romano Heating & Cooling at (916) 274-9021 for professional HVAC repair in Roseville CA."
        },
        {
          question: "Is Romano Heating & Cooling a licensed HVAC contractor in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling is a fully licensed and insured HVAC contractor in Roseville CA. Our contractor license number is #1077499. We've been providing professional AC repair, HVAC repair, furnace repair, and air conditioning service in Roseville CA since 2005."
        },
        {
          question: "What areas do you serve for HVAC repair near Roseville CA?",
          answer: "We provide HVAC repair in Roseville CA and surrounding areas including Rocklin, Folsom, El Dorado, South Placer County, Sacramento County, and San Joaquin County. Our service area covers most of the greater Sacramento region."
        }
      ]
    },
    {
      category: "Furnace Repair Roseville CA",
      faqs: [
        {
          question: "Who provides furnace repair in Roseville CA?",
          answer: "Romano Heating & Cooling is your trusted source for furnace repair in Roseville CA. Our licensed technicians (LIC #1077499) repair all furnace types including gas furnaces, electric furnaces, and heat pumps. We offer same-day furnace repair, annual maintenance, and 24/7 emergency heating services."
        },
        {
          question: "What are signs my furnace needs repair in Roseville CA?",
          answer: "Common signs include strange noises (banging, squealing, rattling), yellow or flickering pilot light, frequent cycling, uneven heating, increased energy bills, and poor air quality. If you notice any of these issues, contact Romano Heating & Cooling at (916) 274-9021 for furnace repair in Roseville CA."
        },
        {
          question: "How often should I have my furnace serviced in Roseville CA?",
          answer: "We recommend annual furnace maintenance in Roseville CA, ideally in the fall before the heating season begins. Regular maintenance ensures safe operation, improves efficiency, and helps prevent unexpected breakdowns during cold weather. Call (916) 274-9021 to schedule service."
        },
        {
          question: "Do you offer emergency furnace repair in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling offers 24/7 emergency furnace repair in Roseville CA. When your heating system fails during cold weather, our technicians are available around the clock to restore your comfort and safety. Call (916) 274-9021 for emergency service."
        }
      ]
    },
    {
      category: "Air Conditioning Service Roseville CA",
      faqs: [
        {
          question: "What does air conditioning service in Roseville CA include?",
          answer: "Air conditioning service in Roseville CA from Romano Heating & Cooling includes: comprehensive AC tune-ups (only $49), refrigerant level checks, coil cleaning, filter replacement, thermostat calibration, electrical connection inspection, and performance testing. Regular service prevents costly breakdowns."
        },
        {
          question: "How often should I schedule air conditioning service in Roseville CA?",
          answer: "We recommend scheduling air conditioning service in Roseville CA at least once per year, preferably in spring before the hot summer months. Our $49 AC tune-up includes comprehensive inspection, cleaning, and performance testing to keep your system running efficiently."
        },
        {
          question: "What is included in your $49 AC Tune-Up in Roseville CA?",
          answer: "Our $49 AC Tune-Up in Roseville CA includes: comprehensive system inspection, cleaning of condenser and evaporator coils, lubrication of moving parts, refrigerant level check, thermostat calibration, electrical connection inspection, and full system performance test."
        },
        {
          question: "Can you install a new air conditioning system in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling provides professional air conditioning installation in Roseville CA. We install all major brands including Lennox, Carrier, Trane, and more. Our technicians will help you choose the right system for your home and budget, and provide expert installation with warranty coverage."
        }
      ]
    },
    {
      category: "Indoor Air Quality",
      faqs: [
        {
          question: "Do you offer air duct cleaning in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling provides professional air duct cleaning in Roseville CA. We recommend having your air ducts cleaned every 3-5 years to improve indoor air quality, reduce allergens, and improve HVAC system efficiency. Call (916) 274-9021 to schedule service."
        },
        {
          question: "What indoor air quality services do you offer in Roseville CA?",
          answer: "We offer comprehensive indoor air quality services in Roseville CA including air duct cleaning, air purification systems, humidity control, UV light installation, and ventilation system installation. These services help reduce allergens, eliminate odors, and create a healthier home environment."
        }
      ]
    },
    {
      category: "General Questions",
      faqs: [
        {
          question: "What are your business hours in Roseville CA?",
          answer: "Romano Heating & Cooling is open Monday through Saturday, 6:00 AM to 10:00 PM. We also offer 24/7 emergency HVAC services for urgent heating and cooling issues. Our office is located at 1316 Church Street, Roseville, CA 95678."
        },
        {
          question: "Do you offer financing for HVAC services in Roseville CA?",
          answer: "Yes, Romano Heating & Cooling offers financing options for major HVAC repairs and new system installations in Roseville CA. We believe everyone deserves a comfortable home, and we work with you to find payment solutions that fit your budget. Call (916) 274-9021 for details."
        }
      ]
    }
  ];

  // Flatten FAQs for schema
  const allFaqs = faqCategories.flatMap(cat => cat.faqs);

  return (
    <div className="min-h-screen bg-[#FDFCF7]">


      {/* Navigation Bar */}
      <div className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-[#622B62] hover:text-[#DA9C3A] transition-colors font-medium"
          >
            <ArrowLeft size={20} />
            Back to Home
          </button>
          <a href={`tel:${companyInfo.phone}`}>
            <Button className="bg-[#DA9C3A] hover:bg-[#C48A2A] text-white font-semibold px-5 py-2 rounded-full">
              <Phone size={16} className="mr-2" />
              {companyInfo.phone}
            </Button>
          </a>
        </div>
      </div>

      {/* Hero Section */}
      <div className="bg-[#622B62] text-white py-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#7A3D7A] rounded-full -translate-y-1/2 translate-x-1/2 opacity-50" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#4A1F4A] rounded-full translate-y-1/2 -translate-x-1/2 opacity-50" />
        
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <div className="w-20 h-20 rounded-full bg-[#DA9C3A] flex items-center justify-center mx-auto mb-6">
            <HelpCircle size={40} />
          </div>
          <h1 className="romano-heading text-4xl sm:text-5xl font-bold mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Find answers to common questions about our HVAC services, maintenance tips, and more.
          </p>
        </div>
      </div>

      {/* NAP Section */}
      <div className="bg-white border-b">
        <div className="max-w-5xl mx-auto px-4 py-6">
          <div className="flex flex-wrap justify-center items-center gap-6 text-center sm:text-left">
            <div className="flex items-center gap-2">
              <span className="font-bold text-[#622B62]">Romano Heating & Cooling</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-gray-300" />
            <div className="text-gray-600">
              1316 Church Street, Roseville, CA 95678
            </div>
            <div className="hidden sm:block w-px h-6 bg-gray-300" />
            <a href="tel:9162749021" className="text-[#DA9C3A] font-semibold hover:text-[#C48A2A]">
              (916) 274-9021
            </a>
          </div>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        {faqCategories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-12">
            <h2 className="romano-heading text-2xl font-bold text-[#622B62] mb-6 flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#DA9C3A] flex items-center justify-center">
                <span className="text-white font-bold text-sm">{categoryIndex + 1}</span>
              </div>
              {category.category}
            </h2>
            
            <Accordion type="single" collapsible className="space-y-4">
              {category.faqs.map((faq, faqIndex) => (
                <AccordionItem
                  key={faqIndex}
                  value={`${categoryIndex}-${faqIndex}`}
                  className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
                >
                  <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-gray-50 text-left">
                    <span className="font-semibold text-[#622B62] pr-4">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 pt-0">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}

        {/* Still Have Questions CTA */}
        <div className="bg-gradient-to-br from-[#622B62] to-[#4A1F4A] rounded-3xl p-10 text-center text-white relative overflow-hidden mt-16">
          <div className="absolute top-0 right-0 w-40 h-40 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />
          
          <div className="relative z-10">
            <HelpCircle size={48} className="text-[#DA9C3A] mx-auto mb-6" />
            <h3 className="romano-heading text-2xl sm:text-3xl font-bold mb-4">
              Still Have Questions?
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Can't find the answer you're looking for? Our friendly team is here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:9162749021">
                <Button className="bg-[#DA9C3A] hover:bg-[#C48A2A] text-white font-bold px-10 py-6 text-lg rounded-full shadow-xl">
                  <Phone size={22} className="mr-2" />
                  Call (916) 274-9021
                </Button>
              </a>
              <Button
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#622B62] font-bold px-10 py-6 text-lg rounded-full"
                onClick={() => navigate('/#contact')}
              >
                Contact Us Online
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer with NAP */}
      <div className="bg-[#622B62] text-white py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img
              src={companyInfo.logo}
              alt="Romano Heating & Cooling"
              className="h-24 w-24 object-contain rounded-lg"
            />
            <div className="text-left">
              <h3 className="font-bold romano-heading">Romano Heating & Cooling</h3>
              <p className="text-white/70 text-sm">1316 Church Street, Roseville, CA 95678</p>
            </div>
          </div>
          <p className="text-[#DA9C3A] font-semibold mb-2">(916) 274-9021</p>
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} Romano Heating and Cooling. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
